/*
 * @Description:账号相关
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-09 12:22:47
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-20 22:13:31
 */
import { fetch, fetchGet } from "@/utils/request";

export default {
  //注册
  register(param) {
    return fetch("/login/sign", param, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  //获取公司列表
  getEnterprise() {
    return fetchGet("/enterprise/getList");
  },
  //密码登录
  loginBypassword(param) {
    return fetch("/login/passWord", param);
  },
  //验证码登录
  loginByCode(param) {
    return fetch("/login/checkLogin", param);
  },
  //发送验证码
  sendCode(param) {
    return fetch("/login/getMessage", param);
  },
  //检查验证码
  checkMessage(param) {
    return fetch("/checkMessage", param);
  },

  //刷新token
  getNewToken(param) {
    return fetch("/login/refreshToken", param);
  },
};
